import { useNavigate, useParams } from "react-router-dom";
import {
  FaClock,
  FaQuestionCircle,
  FaLayerGroup,
  FaPlay,
  FaLanguage,
} from "react-icons/fa";

import { useGetQuizzesQuery } from "../../slices/quizApiSlice";

import { useGetStudentEnglishQuizzesQuery } from "../../slices/englishQuizApiSlice";

const StudentQuizListScreen = () => {
  const { quizId } = useParams();
  const navigate = useNavigate();

  console.log("Quiz ID:", quizId);

  // Quantitative aptitude quizzes
  const {
    data: quantitativeData,
    isLoading: quantitativeLoading,
    error: quantitativeError,
  } = useGetQuizzesQuery();

  // English quizzes
  const {
    data: englishData,
    isLoading: englishLoading,
    error: englishError,
  } = useGetStudentEnglishQuizzesQuery();

  console.log(englishData);

  const quantitativeQuizzes = Array.isArray(quantitativeData)
    ? quantitativeData
    : quantitativeData?.quizzes || [];

  const englishQuizzes = Array.isArray(englishData)
    ? englishData
    : englishData?.quizzes || [];

  // Add a type so the UI can distinguish the quiz category
  const quizzes = [
    ...quantitativeQuizzes.map((quiz) => ({
      ...quiz,
      quizType: "Quantitative Aptitude",
    })),

    ...englishQuizzes.map((quiz) => ({
      ...quiz,
      quizType: "English",
    })),
  ];

  const isLoading = quantitativeLoading || englishLoading;
  const error = quantitativeError || englishError;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-600">
        Loading quizzes...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="rounded-xl bg-red-100 p-5 text-red-700">
          {error?.data?.message || "Unable to load quizzes"}
        </div>
      </div>
    );
  }

  return (
    <div
      className="
        min-h-screen
        bg-gradient-to-br
        from-slate-100
        via-blue-50
        to-indigo-100
        p-6
      "
    >
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-800">
            Available Quizzes
          </h1>

          <p className="mt-2 text-gray-600">
            Select a quiz to generate your question paper and start.
          </p>
        </div>

        {quizzes.length === 0 ? (
          <div
            className="
              rounded-2xl
              bg-white
              shadow
              p-8
              text-center
              text-gray-500
            "
          >
            No quizzes available.
          </div>
        ) : (
          <div
            className="
              grid
              md:grid-cols-2
              lg:grid-cols-3
              gap-6
            "
          >
            {quizzes.map((quiz) => (
              <div
                key={`${quiz.quizType}-${quiz._id}`}
                className="
                  rounded-3xl
                  bg-white
                  shadow-xl
                  p-6
                  hover:shadow-2xl
                  transition
                "
              >
                {/* Quiz type */}
                <div className="mb-3">
                  <span
                    className={`
                      inline-flex
                      items-center
                      gap-2
                      rounded-full
                      px-3
                      py-1
                      text-sm
                      font-semibold
                      ${
                        quiz.quizType === "English"
                          ? "bg-purple-100 text-purple-700"
                          : "bg-blue-100 text-blue-700"
                      }
                    `}
                  >
                    {quiz.quizType === "English" && <FaLanguage />}
                    {quiz.quizType}
                  </span>
                </div>

                <h2 className="text-xl font-bold text-gray-800">{quiz.name}</h2>

                <p
                  className="
                    mt-2
                    text-gray-600
                    line-clamp-3
                  "
                >
                  {quiz.description || "No description available"}
                </p>

                <div className="mt-5 space-y-3">
                  {/* Duration */}
                  <div
                    className="
                      flex
                      items-center
                      gap-3
                      text-gray-700
                    "
                  >
                    <FaClock className="text-blue-600" />
                    <span>{quiz.durationMinutes || 0} minutes</span>
                  </div>

                  {/* Blueprint */}
                  <div
                    className="
                      flex
                      items-center
                      gap-3
                      text-gray-700
                    "
                  >
                    <FaLayerGroup className="text-purple-600" />

                    <span>
                      Blueprint:{" "}
                      {quiz.questionBlueprint ? "Configured" : "Not Available"}
                    </span>
                  </div>

                  {/* Questions */}
                  <div
                    className="
                      flex
                      items-center
                      gap-3
                      text-gray-700
                    "
                  >
                    <FaQuestionCircle className="text-green-600" />

                    <span>
                      Questions Ready:{" "}
                      {quiz.availableQuestions ?? "Check Availability"}
                    </span>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() =>
                    navigate(
                      quiz.quizType === "English"
                        ? `/english-quizzes/${quiz._id}/start`
                        : `/student/quizzes/${quiz._id}/start`,
                      {
                        state: {
                          quizType: quiz.quizType,
                        },
                      },
                    )
                  }
                  className="
    mt-6
    w-full
    rounded-xl
    bg-blue-600
    py-3
    text-white
    font-semibold
    flex
    items-center
    justify-center
    gap-2
    hover:bg-blue-700
  "
                >
                  <FaPlay />
                  Start Quiz
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentQuizListScreen;
